// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ik-z","tupacHeader":"jk-z","tupacHeader2":"kk-z","tupacMenu":"lk-z","tupacMenu2":"mk-z","tupacMain":"nk-z","tupacMain2":"ok-z"};